;(function () {
  'use strict'

  angular
    .module('contrast.modal-rotate-key')
    .controller('RotateKeyModalCtrl', RotateKeyModalCtrl)

  function RotateKeyModalCtrl(
    $uibModalInstance,
    $translate,
    KEY_TYPES,
    title,
    keyType
  ) {
    'ngInject'

    var vm = this

    // Model
    angular.extend(vm, {
      title: title,
      keyType: keyType,
      apiKeyConstant: KEY_TYPES.API_KEY,
      agentKeyConstant: KEY_TYPES.AGENT_USER_SERVICE_KEY,
      userKeyConstant: KEY_TYPES.USER_SERVICE_KEY,
      link_systemKeys: $translate.instant('link_systemKeys'),
      link_personalKeys: $translate.instant('link_personalKeys')
    })

    // API
    angular.extend(vm, {
      cancel: cancel,
      rotate: rotate
    })

    function cancel() {
      $uibModalInstance.dismiss()
    }

    function rotate() {
      $uibModalInstance.close()
    }
  }
})()
